export const LOCKED_COLUMN_COUNT = 4;
